import script from "./PageSolution.vue?vue&type=script&lang=js"
export * from "./PageSolution.vue?vue&type=script&lang=js"

import "./PageSolution.vue?vue&type=style&index=0&id=73156a24&lang=sass"

const __exports__ = script;

export default __exports__